const Work = () => {
    return (
        <>
            <h1 className="mt-40 ml-44 text-4xl font-extrabold">WORK PAGE</h1>
        </>
    )
}
export default Work